<template>
  <v-card tile>
    <v-card-title class="subtitle-1 font-weight-bold px-6">
      {{ translations.storeSubscriptionInfo[lang] }}
      <v-spacer></v-spacer>
      <v-btn icon @click="$emit('cancel')">
        <v-icon v-text="icons.mdiClose"></v-icon>
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>
    <v-card-text class="pt-4 pb-1">
      <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
        {{ translations.name[lang] + ': ' + storeSubscriptionInfo.store.name }}
      </v-sheet>
      <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
        {{ translations.storeName[lang] + ': ' + storeSubscriptionInfo.store.app_name }}
      </v-sheet>
      <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
        {{
          translations.description[lang] +
          ': ' +
          storeSubscriptionInfo.store_subscription_plan.plan_description[lang]
        }}
      </v-sheet>
      <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
        {{ translations.vat[lang] + ': ' + storeSubscriptionInfo.store_subscription_plan.vat }}
      </v-sheet>
      <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
        {{ translations.email[lang] + ': ' + storeSubscriptionInfo.store.email }}
      </v-sheet>
      <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
        {{ translations.address[lang] + ': ' + storeSubscriptionInfo.store.address }}
      </v-sheet>
      <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
        {{ translations.primary_phone[lang] + ': ' + storeSubscriptionInfo.store.primary_phone }}
      </v-sheet>
      <v-sheet color="rgba(234, 237, 241, 0.57)" outlined class="pa-3 mb-3">
        {{ translations.paymentMethod[lang] + ': ' }}
        {{
          !storeSubscriptionInfo.store_payment_method
            ? '-'
            : storeSubscriptionInfo.store_payment_method.system_payment_method_category.name[lang] +
              ' - ' +
              storeSubscriptionInfo.store_payment_method.system_payment_method.name[lang]
        }}
      </v-sheet>
      <BillingsTable
        :billings="billings"
        :pagination="billingsPagination"
        :headers="headers"
        :hide-credit-subscription-actions="true"
        @page-sync="(p) => (page = p)"
        :subscription="storeSubscriptionInfo"
      />
    </v-card-text>
  </v-card>
</template>

<script>
import { mdiClose } from '@mdi/js';
import { mapState, mapActions } from 'vuex';
import translations from '@/utils/translations/loyaltyPanel/subscriptions/stores';
import BillingsTable from '@/components/general/settings/billingDashboard/BillingsTable.vue';

export default {
  name: 'StoreSubscriptionInfo',
  mixins: [translations],
  components: { BillingsTable },
  data: () => ({
    icons: { mdiClose },
    page: 1,
  }),
  computed: {
    ...mapState(['loading', 'errorMessage']),
    ...mapState('loyaltyPanel/subscriptions/subscriptionBillings', [
      'billings',
      'billingsPagination',
    ]),
    lang() {
      return this.$route.params.lang;
    },
    storeSubscriptionInfo() {
      return this.$store.state.loyaltyPanel.subscriptions.storeSubscriptions.storeSubscriptionInfo;
    },
    headers() {
      return [
        {
          text: this.translations.total[this.lang],
          value: 'total',
          width: '20%',
        },
        {
          text: this.translations.paymentStatus[this.lang],
          value: 'payment_completed',
          width: '30%',
        },
        {
          text: this.translations.period[this.lang],
          value: 'period',
          width: '30%',
          align: 'center',
        },
        {
          text: this.translations.actions[this.lang],
          value: 'actions',
          width: '20%',
          align: 'center',
        },
      ];
    },
    paymentMethodSystem() {
      return (
        this.storeSubscriptionInfo.store_payment_method?.system_payment_method_category?.system ||
        ''
      );
    },
  },
  methods: {
    ...mapActions('loyaltyPanel/subscriptions/subscriptionBillings', ['getBillings']),
    async fetchBillings() {
      let id = this.storeSubscriptionInfo.store_subscription_id;
      let page = this.page;
      if (page && id) {
        await this.getBillings({ id, page });
      }
    },
  },
  watch: {
    ['storeSubscriptionInfo.store_subscription_id']: {
      immediate: true,
      async handler() {
        this.page = 1;
        this.fetchBillings();
      },
    },
    page: {
      async handler() {
        this.fetchBillings();
      },
    },
  },
};
</script>
